<template>
    <div>
        <div>
            <div v-if="!component" class="row align-items-stretch">
                <div class="col-md-4 mb-3 mb-md-0 d-flex">
                    <button
                        type="button"
                        class="option-card w-100 h-100"
                        @click="selectComponent('configCompetitorFile')"
                    >
                        <span class="option-card__icon">
                            <img src="/icons/files.svg" alt="icono">
                        </span>
                        <span class="option-card__title">Cargar archivo XLSX</span>
                        <span class="option-card__action">Subir archivo <span aria-hidden="true">→</span></span>
                    </button>
                </div>

                <div class="col-md-4 mb-3 mb-md-0 d-flex">
                    <button
                        type="button"
                        class="option-card w-100 h-100"
                        @click="selectComponent('configCompetitorGroup')"
                    >
                        <span class="option-card__icon">
                            <img src="/icons/textbox.svg" alt="icono">
                        </span>
                        <span class="option-card__title">Completar formulario</span>
                        <span class="option-card__action">Abrir formulario <span aria-hidden="true">→</span></span>
                    </button>
                </div>

                <div class="col-md-4 d-flex">
                    <button
                        type="button"
                        class="option-card w-100 h-100"
                        @click="selectComponent('configCompetitorCreateOne')"
                    >
                        <span class="option-card__icon">
                            <img src="/icons/textbox.svg" alt="icono">
                        </span>
                        <span class="option-card__title">Crear regla individual</span>
                        <span class="option-card__action">Abrir formulario <span aria-hidden="true">→</span></span>
                    </button>
                </div>
            </div>

            <div v-else class="px-0 mx-0 py-2 d-flex justify-content-between align-items-center">
                <button class="btn rounded border px-4 py-2 fw-600" style="color: #000; background-color: #fff; border-color: #dee2e6;" @click="component = ''">← Volver</button>            
            </div>
            <component v-if="component" :is="component" @refrest="close" @back="component = ''"/>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import configCompetitorFile from './configCompetitorFile.vue'
import configCompetitorGroup from './configCompetitorGroup.vue';
import configCompetitorCreateOne from './configCompetitorCreateOne.vue';
export default {
    name: "config-competitor-options",
    data(){
        return{
            component: ''
        }
    },
    components: {
        configCompetitorFile,
        configCompetitorGroup,
        configCompetitorCreateOne
    },
    methods: {
        ...mapActions(["","executeCommit"]),
        selectComponent(name){
            this.component = name;
        },
        close(){
            this.executeCommit({
                mutation: "close_modal",
            });
            this.$emit("refrest");
        }
    }
}
</script>

<style scoped>
.option-grid {
    margin-top: 10px;
}

.option-grid__cell {
    display: flex;
}

.option-card {
    min-height: 300px;
    height: 100%;
    border: 2px solid #c7c7c7;
    border-radius: 22px;
    background: #ffffff;
    padding: 36px 30px 28px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 12px;
    text-align: left;
    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
    box-shadow: none;
}

.option-card:hover {
    transform: translateY(-2px);
    border-color: #bdbdbd;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);
}

.option-card:focus-visible {
    outline: 3px solid rgba(13, 110, 253, 0.18);
    outline-offset: 3px;
}

.option-card__icon {
    width: 88px;
    height: 88px;
    border-radius: 16px;
    background: #f7f5ef;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 6px;
}

.option-card__icon img {
    width: 38px;
    height: 38px;
    object-fit: contain;
}

.option-card__title {
    font-size: 1.28rem;
    line-height: 1.2;
    font-weight: 700;
    color: #232323;
}

.option-card__text {
    max-width: 290px;
    font-size: 1.02rem;
    line-height: 1.45;
    color: #4a4a4a;
}

.option-card__action {
    margin-top: auto;
    padding-top: 16px;
    width: 100%;
    border-top: 1px solid #e6e6e6;
    font-size: 1.02rem;
    line-height: 1.2;
    font-weight: 700;
    color: #222222;
    display: flex;
    align-items: center;
    gap: 10px;
}

@media (max-width: 767.98px) {
    .option-card {
        min-height: 320px;
        padding: 28px 22px 24px;
    }

    .option-card__title {
        font-size: 1.15rem;
    }

    .option-card__text {
        font-size: 0.98rem;
    }

    .option-card__action {
        font-size: 0.98rem;
    }
}
</style>
